import { render, staticRenderFns } from "./reprocessedPlastic.vue?vue&type=template&id=f57631b2&scoped=true"
import script from "./reprocessedPlastic.vue?vue&type=script&lang=js"
export * from "./reprocessedPlastic.vue?vue&type=script&lang=js"
import style0 from "./reprocessedPlastic.vue?vue&type=style&index=0&id=f57631b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57631b2",
  null
  
)

export default component.exports